<template>
  <div class="card">
    <div class="card-header">
      <div>
        <h3>Динамика новостного потока</h3>
        <span class="subtitle">Общее количество новостей за выбранный период</span>
      </div>
      <div class="card-actions">
        <RefreshIcon @click="refresh" />
        <CalendarInput v-model="localDate" />
      </div>
    </div>
    <div 
      v-if="hasData"
      class="chart-wrapper"
    >
      <Apexchart 
        type="area" 
        height="300" 
        :options="chartOptions" 
        :series="chartSeries"
      />
    </div>
    <div 
      v-else
      class="no-data-placeholder"
    >
      <div class="no-data-content">
        <h4>Нет данных</h4>
        <p>За выбранный период данных не найдено</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from "vue";
import VueApexCharts from "vue3-apexcharts";
import CalendarInput from "@/components/UI/CalendarInput.vue";
import RefreshIcon from "@/components/icons/RefreshIcon.vue";
import { useAnalyticsStore } from "@/stores/analytics";
import { formatDateForX, formatDateForRequest } from "@/tools/time";

const Apexchart = VueApexCharts;
const analyticsStore = useAnalyticsStore();

const localDate = ref([new Date(new Date().setDate(new Date().getDate() - 7)), new Date()]);

watch(localDate, (newVal) => {
  if (newVal?.[0] && newVal?.[1]) {
    analyticsStore.fetchNewsFlow({
      startDate: formatDateForRequest(newVal[0]),
      endDate: formatDateForRequest(newVal[1]),formatDateForRequest
    });
  }
});

const refresh = () => {
    analyticsStore.fetchNewsFlow({
      startDate: formatDateForRequest(localDate.value[0]),
      endDate: formatDateForRequest(localDate.value[1]),
    });
};

const hasData = computed(() => analyticsStore.newsFlow && analyticsStore.newsFlow.length > 0);

const chartSeries = computed(() => [{
  name: "Новостей",
  data: analyticsStore.newsFlow.map(item => item.count) || []
}]);

const chartOptions = computed(() => ({
  chart: {
    type: "area",
    toolbar: { show: false },
    zoom: { enabled: false },
    fontFamily: "Inter, sans-serif"
  },
  colors: ["#FFB547"],
  dataLabels: { enabled: false },
  stroke: { curve: "smooth", width: 2 },
  fill: {
    type: "gradient",
    gradient: {
      shadeIntensity: 1,
      opacityFrom: 0.6,
      opacityTo: 0.1,
      stops: [0, 90, 100]
    }
  },
  xaxis: {
    categories: analyticsStore.newsFlow.map(item => formatDateForX(item.date)) || [],
    axisBorder: { show: false },
    axisTicks: { show: false },
    labels: { style: { colors: "#7B87A5" } }
  },
  yaxis: {
    labels: { style: { colors: "#7B87A5" } }
  },
  grid: {
    borderColor: "#F1F1F1",
    strokeDashArray: 4
  }
}));

onMounted(() => {
  const params = {
    startDate: formatDateForRequest(localDate.value[0]),
    endDate: formatDateForRequest(localDate.value[1])
  };

  analyticsStore.fetchNewsFlow(params);
});
</script>

<style scoped>
.card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.03);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.card-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #1A1D1F;
}

.subtitle {
  font-size: 12px;
  color: #9A9FA5;
  margin-top: 4px;
  display: block;
}

.card-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.no-data-placeholder {
  height: 300px;
  background: #F8F9FB;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.no-data-content h4 {
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 600;
  color: #304758;
}

.no-data-content p {
  margin: 0;
  font-size: 14px;
  color: #7B87A5;
}
</style>
